import { useState } from "react";

// Materials UI
import { Button, DialogActions, Grid } from "@mui/material";

// Icons
import { Add, CheckBoxOutlineBlank } from "@mui/icons-material";

// Components
import DataGrid from "../../../../components/grid"
import Modal from "../../../../components/modal";
import ReferralFilters from "../../../stocks/referrals/ReferralFilters";
import { headers } from "../../../../models/ReferralEntities";

// Hooks
import useReferrals from "../../../../hooks/referrals/useReferrals";
import useReception from "../../../../hooks/reception/useReception";

const defaultFilters = {
    pageNumber: 1,
    pageSize: 10,
    state: 'Remitted',
    excludedIds: null
};

const ReferralsModal = ({ open, onClose, referralsAssigned }) => {
    // State
    const [filters, setFilters] = useState({ ...defaultFilters, excludedIds: referralsAssigned?.map(rf => typeof rf === 'object' ? rf.referralId : rf ) });
    const [referralsSelected, setReferralsSelected] = useState([]);

    const { addReferral, loading: saving } = useReception();
    const { referrals, loading, totalPage } = useReferrals(filters, true);

    const handlePageChange = (e, page) =>
        setFilters(state => ({ ...state, pageNumber: page }));

    const handleClearFilters = () =>
        setFilters(defaultFilters);

    const handleAccept = () => {
        addReferral(referralsSelected);
        onClose();
    }

    const handleItemSelection = (selected, referral) => {
        if (!selected) {
            setReferralsSelected(state => state.filter(referralId => referralId !== referral.id))
        } else
            setReferralsSelected(state => ([...state, referral.id]))
    }

    const handleUnSelectAll = () =>
        setReferralsSelected([])

    const isSelected = (referral) =>
        !!referralsSelected.find(referralId => referralId === referral.id);

    return (
        <Modal
            maxWidth='xl'
            open={open}
            onClose={onClose}
            title='Remitos'
            contentProps={{
                dividers: true
            }}
            customButtons={() =>
                <DialogActions>
                    <Button
                        startIcon={<CheckBoxOutlineBlank />}
                        variant='contained'
                        color='primary'
                        disabled={saving}
                        onClick={() => handleUnSelectAll()}
                    >
                        Deseleccionar todos
                    </Button>
                    <Button
                        startIcon={<Add />}
                        variant='contained'
                        color='primary'
                        disabled={!referralsSelected.length}
                        onClick={handleAccept}
                    >
                        {`Agregar (${referralsSelected.length})`}
                    </Button>
                </DialogActions>
            }
        >
            <Grid container spacing={1}>
                <Grid size={12}>
                    <ReferralFilters
                        disabledStateFilter
                        filters={filters}
                        setFilters={setFilters}
                        clearFilters={handleClearFilters}
                    />
                </Grid>
                <Grid size={12}>
                    <DataGrid
                        heads={headers.map(h => h.label)}
                        keyColumns={headers.map(h => h.field)}
                        columnSizes={headers.map(h => h.size)}
                        items={referrals?.map(r => ({
                            id: r.id,
                            number: r.number,
                            state: r.state,
                            created: r.created,
                            warehouseOrigen: r.warehouseOrigen.name,
                            warehouseDestination: r.warehouseDestination.name
                        })) || []}
                        loading={loading}
                        pageNumber={filters.pageNumber}
                        totalPage={totalPage}
                        onChangePage={handlePageChange}
                        isSelected={isSelected}
                        onSelect={handleItemSelection}
                    />
                </Grid>
            </Grid>
        </Modal>
    );
}

export default ReferralsModal;